import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext();

function getStoredToken() {
  try { return localStorage.getItem("wedowedo_token"); } catch { return null; }
}

function setStoredToken(token) {
  try { if (token) localStorage.setItem("wedowedo_token", token); else localStorage.removeItem("wedowedo_token"); } catch {}
}

function authHeaders() {
  const token = getStoredToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = getStoredToken();
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        withCredentials: true,
        headers: authHeaders(),
      });
      setUser(data);
    } catch {
      setStoredToken(null);
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    if (data.access_token) {
      setStoredToken(data.access_token);
    }
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true, headers: authHeaders() });
    } catch {}
    setStoredToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
